import { format } from '@teetsh/app/src/utils/time/format';
import { getPreviousDayBasedOnViewAndWorkingDays } from '@teetsh/app/src/utils/time';
import { isoDatePatternWithSlashes } from '@teetsh/app/src/utils/time/datePatterns';
import { CahierJournalView } from 'containers/CahierJournal/types';

export function getPreviousDateUrl(
  view: CahierJournalView,
  date: Date,
  workingDays: number[],
) {
  const previousDay = getPreviousDayBasedOnViewAndWorkingDays(
    view,
    date,
    workingDays,
  );
  return `cahier-journal/${view}/${format(
    previousDay,
    'fr-FR',
    isoDatePatternWithSlashes,
  )}`;
}
